import { render } from "./Classrooms.vue?vue&type=template&id=f84b73b2&ts=true"
import script from "./Classrooms.vue?vue&type=script&lang=ts"
export * from "./Classrooms.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__